import { FormHandles, SubmitHandler } from "@unform/core";
import { Form } from "@unform/web";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";

import { Form as FormInput } from "react-bootstrap";
import DataNotFound from "../../../../../../components/DataNotFound";
import DataTable from "../../../../../../components/DataTable";
import { InputDecimal } from "../../../../../../components/Form";
import { SweetAlertContext } from "../../../../../../contexts/sweetAlert/alertContext";
import { ToastContext } from "../../../../../../contexts/toast/toastContext";
import api from "../../../../../../services/api";
import * as Yup from "yup";

const TabTamanhosBarra: React.FC<any> = ({ material }) => {
  const formRef = useRef<FormHandles>(null);

  const sweetAlertContext = useContext(SweetAlertContext);
  const toastContext = useContext(ToastContext);
  const [reload, setReload] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  const schema = Yup.object().shape({
    TamanhoBarra: Yup.string()
      .required("O tamanho da barra é obrigatório")
      .matches(/^\d{4}$/, "O tamanho deve conter 4 dígitos")
      .test("maior-que-zero", "O valor deve ser maior que 1000", (value) => {
        if (!value) return false;
        const numeric = parseInt(value, 10);
        return numeric > 0;
      }),
  });

  useEffect(() => {
    (async () => {
      try {
        setTableLoading(true);
        if (material?.id != undefined) {
          const endpoint = `perfil/Barras/${material?.id}`;
          const { data: data } = await api.get(endpoint);

          setTableData(data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setTableLoading(false);
      }
    })();
  }, [material, reload]);

  const handleSubmit: SubmitHandler<any> = async (item, { reset }) => {
    try {
      formRef.current?.setErrors({});
      await schema.validate(item, { abortEarly: false });

      const valorNumerico = parseInt(item.TamanhoBarra.replace(/\D/g, ""), 10);

      const perfilBarra = {
        tamanhoBarra: valorNumerico,
        idperfil: material?.id,
      };

      await api.post("perfil/SalvarBarra", perfilBarra);

      setReload((reload) => !reload);
      reset();
      toastContext.notification("Barra adicionada com sucesso!", "success");
    } catch (error: any) {
      if (error.name === "ValidationError") {
        const validationErrors: Record<string, string> = {};
        error.inner.forEach((err: any) => {
          if (err.path) validationErrors[err.path] = err.message;
        });
        formRef.current?.setErrors(validationErrors);
      } else {
        toastContext.notification("Erro ao salvar Barra.", "error");
      }
    }
  };

  const handleDelete = (item: any) => {
    sweetAlertContext.danger(
      "Excluir Barra?",
      "Essa ação não pode ser desfeita.",
      async () => {
        try {
          const endpoint = `perfil/RemoverBarra/${item.idPerfilBarras}`;
          await api.delete(endpoint);
          setTableData((prevState: any) =>
            prevState.filter(
              (i: any) => i.idPerfilBarras !== item.idPerfilBarras
            )
          );
          sweetAlertContext.close();
        } catch (error) {
          toastContext.notification("Erro ao excluir o Barra.", "error");
        }
      }
    );
  };
  const columns = [
    { Header: "Barra", accessor: "tamanhoBarra" },
    {
      Header: "Ações",
      accessor: "acao",
      Cell: ({ row: { original } }: { row: { original: any } }) => (
        <Button
          variant="ghost-dark"
          className="p-2"
          onClick={() => handleDelete(original)}
        >
          <i className="far fa-trash-alt icon m-0"></i>
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="row mb-3"></div>

      <Form ref={formRef} onSubmit={handleSubmit}>
        <div className="row">
          <FormInput.Group className="col-3">
            <FormInput.Label>Tamanho da barra</FormInput.Label>
            <InputDecimal
              type="text"
              name="TamanhoBarra"
              className="form-control"
              placeholder="1000"
              displayType="input"
              decimalSeparator=","
              valueIsNumericString
              isAllowed={(values: any) => {
                const { formattedValue, floatValue } = values;
                return formattedValue === "" || floatValue <= 9999;
              }}
              maxLength={4}
            />
          </FormInput.Group>
          <FormInput.Group
            className="col d-flex"
            style={{ alignItems: "flex-end", height: "63px" }}
          >
            <Button
              variant="white"
              onClick={() => formRef.current?.submitForm()}
            >
              Adicionar
            </Button>
          </FormInput.Group>
        </div>
      </Form>

      <div
        className={"dimmer" + (tableLoading ? " active" : "")}
        style={tableLoading ? { minHeight: "322px" } : {}}
      >
        <div className="loader"></div>
        <div className="dimmer-content">
          {tableData && tableData.length > 0 ? (
            <DataTable
              columns={columns}
              data={tableData}
              setSelectedRows={undefined}
            />
          ) : (
            <DataNotFound visible={!tableLoading} />
          )}
        </div>
      </div>
    </>
  );
};

export default TabTamanhosBarra;
